import { CheckoutProps } from '@wix/checkout-components';
import { FedopsReporter } from '../../../../types';

export interface UseBeforeInitOptions {
  beginCreateOrderPageHttpRequestInteraction: FedopsReporter;
}

export function useBeforeInit(
  options?: UseBeforeInitOptions,
): CheckoutProps['beforeInit'] | undefined {
  if (options) {
    return async () => {
      options.beginCreateOrderPageHttpRequestInteraction();
    };
  }

  return undefined;
}
